/* 
   removeTeacher - will receive the UID of a user, iterate through the documents of the database to find a match, 
                  then call deleteTeacher to remove the teacher and their information from the user table
   updateTeacherInfo - will receive the UID of a user, iterate through the documents of the database to find a match, 
                  then call updateTeacherStatus to change a teachers verified status to true
   getTeacher - get teachers information based on document id
   updateTeacherStatus - updating a teachers verified state to true if admin approves them
   deleteTeacher - will disable a teacher account if an admin decides to delete them; we are disabling for now bc we 
                  are unsuure if that data show be completely deleted from the database yet
                  however the teacher will be deleted from the user table but moved to the "disabledusers" table
   readPending - reading the teachers who have an isVerified (false) and putting them into an array for teachers to be added
   verification - gets if a specific teacher is verified by their email address
   getUserData - gets the uid of a teacher and returns all their current information from the database
*/

import { db } from "../firebase/config";
import {
  collection,
  getDocs,
  getDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { disableUser } from "./DisabledUsersData";

const userCollectionRef = collection(db, "users");

export const getTeacher = async (id) => {
  const dataRef = doc(db, "users", id);
  const dataSnap = await getDoc(dataRef);
  return { ...dataSnap.data() };
};

const updateTeacherStatus = async (id) => {
  const userdoc = doc(db, "users", id);
  const addField = { isVerified: true };
  await updateDoc(userdoc, addField);
};

const deleteTeacher = async (id, instructor) => {
  disableUser(instructor);
  const teachDoc = doc(db, "users", id);
  await deleteDoc(teachDoc);
};

export const removeTeacher = async (id) => {
  const data = await getDocs(userCollectionRef);
  const users = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));

  await Promise.all(
    users.map(async(teachers) => {
      const instructor = await getTeacher(teachers.id);
      if(instructor.id == id){
        deleteTeacher(teachers.id, instructor);
      }
    })
  );
};

export const updateTeacherInfo = async (id) => {
  const data = await getDocs(userCollectionRef);
  const users = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));

  await Promise.all(
    users.map(async(teachers) => {
      const instructor = await getTeacher(teachers.id);
      if(instructor.id == id){
        updateTeacherStatus(teachers.id);
      }
    })
  );
};

export const getUserData = async (id) => {
  const data = await getDocs(userCollectionRef);
  const users = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
  let list = [];

  await Promise.all(
    users.map(async (teachers) => {
      const instructor = await getTeacher(teachers.id);
      if(instructor.id == id){
        list.push({
          department: instructor.department,
          email: instructor.email,
          id: instructor.id,
          isVerified: instructor.isVerified,
          name: instructor.name,
          num: instructor.num,
          role: instructor.role
        });
      }
    }),
  );
  return list;
};

export const readPending = async () => {
  const data = await getDocs(userCollectionRef);
  const users = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
  let list = [];

  await Promise.all(
    users.map(async (teachers) => {
      const instructor = await getTeacher(teachers.id);
      if (instructor.role == "instructor" && instructor.isVerified === false) {
        list.push({
          id: instructor.id,
          teacherid: instructor.num,
          name: instructor.name,
          email: instructor.email,
          department: instructor.department,
        });
      }
    }),
  );
  return list;
};

export const verification = async (email) => {
  const data = await getDocs(userCollectionRef);
  const users = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
  let verified = false;

  await Promise.all(
    users.map(async (teachers) => {
      const instructor = await getTeacher(teachers.id);
      if (instructor.email === email) {
        verified = instructor.isVerified;
      }
    }),
  );
  return verified;
};
